(function () {
  let isAnimating = false; // Flag to track animation state

  const initCollapsibleContent = () => {
    $('.collapsible-content__toggle')
      .unbind('click')
      .on('click', function () {
        if (isAnimating) return; // Prevent action if animation is ongoing

        const parent = $(this).parent();
        isAnimating = true; // Set flag to true to indicate animation start

        if (!parent.hasClass('active')) {
          parent
            .siblings('.collapsible-content__item.active')
            .removeClass('active')
            .find('.collapsible-content__answer')
            .stop()
            .slideUp(300);

          parent.addClass('active');
          $(this)
            .next()
            .stop()
            .slideDown(300, function () {
              isAnimating = false; // Reset flag after animation completes
            });

          // Image swap logic with smooth transition
          const newSrc = $(this)
            .find('.collapsible-content__question')
            .data('image-src');
          const newSrcset = $(this)
            .find('.collapsible-content__question')
            .data('image-srcset');
          const imageContainer = $('.js-custom-tab-image img');

          if (newSrc && imageContainer.length) {
            imageContainer.addClass('smooth-transition'); // Start fade out
            setTimeout(() => {
              const tempImage = new Image();
              tempImage.src = newSrc;
              tempImage.onload = function () {
                imageContainer.attr('src', newSrc);
                imageContainer.attr('srcset', newSrcset);
                imageContainer.removeClass('smooth-transition'); // Fade in after image loads
              };
            }, 300); // Wait for fade out to complete
          }
        } else {
          parent.removeClass('active');
          $(this)
            .next()
            .stop()
            .slideUp(300, function () {
              isAnimating = false; // Reset flag after animation completes
            });
        }
      });

    $('.collapsible-content__item').mouseenter(function (event) {
      $(this).removeClass('collapsible-content__item--opacity');
      $(this).siblings().addClass('collapsible-content__item--opacity');
      $(this).mouseleave(() => {
        $(this).siblings().removeClass('collapsible-content__item--opacity');
      });
    });
  };

  document.addEventListener('shopify:section:load', function () {
    initCollapsibleContent();
  });

  initCollapsibleContent();
})();
